import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Experience Strategy", desc: "Translate user intent and business objectives into product interaction models." },
  { title: "Interface Systems", desc: "Design systems that improve consistency, speed, and engineering handoff quality." },
  { title: "Conversion-Focused UX", desc: "Flows optimized to reduce friction and increase completion rates." },
  { title: "Prototype Validation", desc: "Rapid prototyping and usability testing before heavy development spend." },
  { title: "Cross-Device Design", desc: "Responsive behavior tuned for desktop, tablet, and mobile usage patterns." },
  { title: "Design-to-Dev Workflow", desc: "Structured collaboration so shipped output matches design intent." },
];

const UIUXDesign = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="Interface design for"
    titleAccent="real outcomes."
    subtitle="High-fidelity UX and UI systems built to elevate usability, trust, and conversion performance."
    features={features}
    ctaLabel="START UX DESIGN"
  />
);

export default UIUXDesign;